window.addEventListener('DOMContentLoaded', function () {

  if (!customElements.get("media-gallery-group")) {

    customElements.define(
      "media-gallery-group",
      class MediaGalleryGroup extends HTMLElement {

        constructor() {
          super();

          var _this = this,
            secId = this.dataset.section;

          this.el = {
            main: this.querySelector('.product-image__slider'),
            thumb: this.querySelector('.product-thumb__list'),
            thumbPos: this.querySelector('.product-thumbnails.bottom'),
            pstyle: this.dataset.style
          };

          this.mql = window.matchMedia('(min-width: 767px)');

          this.init();

          this.imgZoom = this.querySelectorAll(".przoom");

          if (this.imgZoom.length > 0) {
            this.zoomImage();
          }

          var variants = document.querySelector(`#variant-selects-${secId}`);

          /*
           * BELANGRIJK:
           * Alleen de kleurkeuze mag de afbeeldingsgalerij wisselen.
           * Andere opties zoals koelkast, kookplaat en gootsteen
           * mogen de galerij niet verbergen.
           */
          if (variants) {

            var colorOptions = variants.querySelectorAll('.swatch-input.clr');

            colorOptions.forEach((opt) => {

              opt.addEventListener("change", function () {

                var selectedColor = opt.value,
                  galleryColor = _this.dataset.color;

                if (selectedColor == galleryColor) {

                  _this.classList.remove('hide');
                  _this.classList.add('active');

                  _this.init();

                } else {

                  _this.classList.add('hide');
                  _this.classList.remove('active');

                }

              });

            });

          }

        }

        zoomImage() {

          if (window.innerWidth >= 1024) {

            this.imgZoom.forEach((img) => {

              var container = img.closest('.przoom');

              new Drift(img, {
                paneContainer: container,
                inlinePane: false,
                zoomFactor: 2
              });

            });

          }

        }

        init() {

          this.enableSwiper();
          this.checkBreakpoint();

        }

        getDirection() {

          if (this.el.thumbPos != null) {

            var direction = "horizontal";

          } else {

            var direction =
              window.innerWidth >= 767
                ? "vertical"
                : "horizontal";

          }

          return direction;

        }

        enableSwiper() {

          if (!this.el.main) return;

          var isSwiper =
            this.el.main.classList.contains('swiper-initialized');

          if (isSwiper) return;

          this.prslider = new Swiper(
            this.el.main,
            JSON.parse(
              this.el.main.getAttribute("data-swiper")
            )
          );

          if (
            this.prslider.thumbs &&
            this.prslider.thumbs.swiper
          ) {

            this.prslider.thumbs.swiper.changeDirection(
              this.getDirection()
            );

          }

          var pslider = this.prslider;

          this.prslider.on("slideChange", function () {

            var slides = pslider.slides;

            for (var i = 0; i < slides.length; i++) {

              var video =
                slides[i].querySelector('video');

              if (video) {

                if (i === pslider.activeIndex) {

                  video.play();

                } else {

                  video.pause();

                }

              }

            }

          });

        }

        checkBreakpoint() {

          if (!this.prslider) return;

          if (
            this.el.pstyle != "1" &&
            this.el.pstyle != "5" &&
            this.el.pstyle != "6"
          ) {

            if (this.mql.matches === true) {

              if (
                this.prslider !== undefined &&
                this.prslider.initialized
              ) {

                this.prslider.destroy();

              }

            } else if (this.mql.matches === false) {

              if (!this.prslider.initialized) {
                this.prslider.init();
              }

              if (
                this.prslider.thumbs &&
                this.prslider.thumbs.swiper
              ) {

                this.prslider.thumbs.swiper.changeDirection(
                  this.getDirection()
                );

              }

            }

          } else {

            if (!this.prslider.initialized) {
              this.prslider.init();
            }

            if (
              this.prslider.thumbs &&
              this.prslider.thumbs.swiper
            ) {

              this.prslider.thumbs.swiper.changeDirection(
                this.getDirection()
              );

            }

          }

        }

      }
    );

  }

  const mediaGalleryGroups =
    document.querySelectorAll('media-gallery-group');

  window.addEventListener("resize", () => {

    mediaGalleryGroups.forEach((group) => {
      group.init();
    });

  });

});